import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from '@/contexts/AuthContext'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { LoginForm } from '@/components/LoginForm'
import { ResetPasswordForm } from '@/components/ResetPasswordForm'
import { ConfirmMobile } from '@/components/ConfirmMobile'
import { ResetPasswordMobile } from '@/components/ResetPasswordMobile'
import { PatientsPage } from '@/pages/PatientsPage'
import { PatientPageWrapper } from '@/pages/PatientPageWrapper'
import { ClinicianListPage } from '@/pages/ClinicianListPage'
import { ClinicianDetailPage } from '@/pages/ClinicianDetailPage'
import { StudyListPage } from '@/pages/StudyListPage'
import { StudyDetailPage } from '@/pages/StudyDetailPage'
import { UsersPage } from '@/pages/UsersPage'
import { FirmwareManagementPage } from '@/pages/FirmwareManagementPage'
import { DeviceListPage } from '@/pages/DeviceListPage'
import { DeviceDetailPage } from '@/pages/DeviceDetailPage'
import { ClinicianDevicesPage } from '@/pages/ClinicianDevicesPage'
import { ClinicianDeviceDetailPage } from '@/pages/ClinicianDeviceDetailPage'
import { RoleBasedRedirect } from '@/components/RoleBasedRedirect'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/login/:tokenHash" element={<LoginForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/reset-password/:tokenHash" element={<ResetPasswordForm />} />
          <Route
            path="/confirm_mobile/:tokenHash"
            element={<ConfirmMobile />}
          />
          <Route
            path="/reset-password-mobile/:tokenHash"
            element={<ResetPasswordMobile />}
          />

          {/* Main application routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <RoleBasedRedirect />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patients"
            element={
              <ProtectedRoute>
                <PatientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <PatientsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patient/:patientId"
            element={
              <ProtectedRoute>
                <PatientPageWrapper />
              </ProtectedRoute>
            }
          />
          <Route
            path="/patient/:patientId/raw-data"
            element={
              <ProtectedRoute>
                <PatientPageWrapper />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinicians"
            element={
              <ProtectedRoute>
                <ClinicianListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinicians/:clinicianId"
            element={
              <ProtectedRoute>
                <ClinicianDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinicians/:clinicianId/devices"
            element={
              <ProtectedRoute>
                <ClinicianDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinicians/:clinicianId/patients"
            element={
              <ProtectedRoute>
                <ClinicianDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studies"
            element={
              <ProtectedRoute>
                <StudyListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studies/:studyId"
            element={
              <ProtectedRoute>
                <StudyDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studies/:studyId/clinicians"
            element={
              <ProtectedRoute>
                <StudyDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/studies/:studyId/patients"
            element={
              <ProtectedRoute>
                <StudyDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/firmware"
            element={
              <ProtectedRoute>
                <FirmwareManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices"
            element={
              <ProtectedRoute>
                <DeviceListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId/users"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId/raw-data"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId/bluetooth-logs"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId/tests"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devices/:deviceId/studies"
            element={
              <ProtectedRoute>
                <DeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices"
            element={
              <ProtectedRoute>
                <ClinicianDevicesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices/:deviceId"
            element={
              <ProtectedRoute>
                <ClinicianDeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices/:deviceId/users"
            element={
              <ProtectedRoute>
                <ClinicianDeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices/:deviceId/raw-data"
            element={
              <ProtectedRoute>
                <ClinicianDeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices/:deviceId/tests"
            element={
              <ProtectedRoute>
                <ClinicianDeviceDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clinician/devices/:deviceId/studies"
            element={
              <ProtectedRoute>
                <ClinicianDeviceDetailPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
